<template>
  <div>
    <h6>Verified History</h6>
    <broadcast-history :verified="1" :get_automation="1" :get_automation_without_action="0" :allowFilterBy="true" :showAllTests="true" :edit-mode="false" :formHeader="false" statusId="0" formTitle=""></broadcast-history>
  </div>
</template>

<script>
export default {
  components: {
    broadcastHistory: () => import('@/modules/voip-testing-panel/old-broadcast-history/page/View.vue'),
  }
}
</script>
